import { call, put, select, takeLatest } from "redux-saga/effects";
import { GET } from "../../api";
import ApiRouts from "../../api/routes";
import { FETCH_FAVORITE_COLLECTION } from "../actions";
import { setFavoriteCollection } from "./action";
import { setTotalCount } from "../slices/totalCountSlice";

const getCurrentPage = (state) => state.currentPage.currentPage;

const getSelectColorId = (state) => state.selectColor.selectColor

const getSearchInputContent = (state) => state.searchInputContent.searchInputContent;

const getSelectedSpaceId = (state) => state.selectSpace.selectSpace

const getFreeState = (state) => state.freeCheckbox

function* fetchFavoriteCollection() {

    const currentPage = yield select(getCurrentPage);
    const selectedColorId = yield select(getSelectColorId);
    const selectedSpaceId = yield select(getSelectedSpaceId);
    const searchInputContent = yield select(getSearchInputContent);
    const freeState = yield select(getFreeState);


    try {

        const url = ApiRouts.API_FAVORITE_COLLECTION({
            free:freeState,
            selectedColorId,
            selectedSpaceId,
            searchInputContent,
            page:currentPage
        })

        const response = yield call(GET, url);
        if (response) {
            yield put(setFavoriteCollection(response.data));
            yield put(setTotalCount(response.data.meta.total));
        } else {
        }
    } catch (error) {
    }
}

function* favoriteCollectionSaga() {
    yield takeLatest(FETCH_FAVORITE_COLLECTION, fetchFavoriteCollection);
}


export default favoriteCollectionSaga;
